import React, {useState, forwardRef, useImperativeHandle} from "react";
import {Tooltip, Space} from "antd";
import {Row, Col} from 'reactstrap';
import RequestedFile from "../../Pages/Request/RequestFile";
import {createPicker, googleSignin} from '../../services/gDrive.service';
import './FilePicker.css';

const FilePicker = forwardRef(({pickerData, disabled}, ref) => {
    const [fileName, setFileName] = useState(null);

    useImperativeHandle(
        ref,
        () => ({
            clearSelectedFile() {
                setFileName(null);
                pickerData(null);
            }
        }),
    )

    const pickerHandler = async (type) => {
        const isSignIn = window.gapi.auth2.getAuthInstance().isSignedIn.get();
        if (isSignIn) {
            createPicker(type, (file) => {
                const {name, id} = file;
                setFileName(name);
                file.isDocFile = type === 'DOCS';
                pickerData({...file});
            })
        } else {
            googleSignin((res) => {
                res && pickerHandler(type);
            });
        }
    }

    const removeFileHandler = () => {
        setFileName(null);
        pickerData(null)
    }

    return (
        <div style={disabled ? {pointerEvents: "none", opacity: "0.4"} : {}}>
            <Row>
                <Col>
                    <Space>
                        <Tooltip title="Select document from google drive">
                            <svg style={{cursor: 'pointer'}} onClick={() => pickerHandler('DOCS')}
                                 xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 48 48"
                                 width="40px"
                                 height="40px">
                                <path fill="#2196f3"
                                      d="M37,45H11c-1.657,0-3-1.343-3-3V6c0-1.657,1.343-3,3-3h19l10,10v29C40,43.657,38.657,45,37,45z"/>
                                <path fill={fileName ? '#1724c2' : '#bbdefb'} d="M40 13L30 13 30 3z"/>
                                <path fill="#1565c0" d="M30 13L40 23 40 13z"/>
                                <path fill={fileName ? '#FFFFFF' : '#bbdefb'}
                                      d="M15 23H33V25H15zM15 27H33V29H15zM15 31H33V33H15zM15 35H25V37H15z"/>
                            </svg>
                        </Tooltip>
                        <span>OR</span>
                        <Tooltip title="Select your youtube video">
                            <svg style={{cursor: 'pointer'}}
                                 xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 48 48" width="48px" height="48px"
                                 onClick={() => pickerHandler('YOUTUBE')}>
                                <path fill="#FF3D00"
                                      d="M43.2,33.9c-0.4,2.1-2.1,3.7-4.2,4c-3.3,0.5-8.8,1.1-15,1.1c-6.1,0-11.6-0.6-15-1.1c-2.1-0.3-3.8-1.9-4.2-4C4.4,31.6,4,28.2,4,24c0-4.2,0.4-7.6,0.8-9.9c0.4-2.1,2.1-3.7,4.2-4C12.3,9.6,17.8,9,24,9c6.2,0,11.6,0.6,15,1.1c2.1,0.3,3.8,1.9,4.2,4c0.4,2.3,0.9,5.7,0.9,9.9C44,28.2,43.6,31.6,43.2,33.9z"/>
                                <path fill="#FFF" d="M20 31L20 17 32 24z"/>
                            </svg>
                        </Tooltip>
                    </Space>
                </Col>
            </Row>
            {
                fileName && (
                    <Row>
                        <Col>
                            <RequestedFile fileName={fileName} removeFile={removeFileHandler}/>
                        </Col>
                    </Row>
                )
            }
        </div>
    )
})
export {FilePicker}